import { Domain } from 'src/app/shared/services/api/bulk-assessments/bulk-assessment.service';

export interface BulkAssessmentState {
  selectedDomain: Domain | null;
  classId: number | null;
  standard: string | null;
  assessmentPeriodId: number | null;
  targetedLang: string | null;
}

export const initialState: BulkAssessmentState = {
  selectedDomain: null,
  classId: null,
  standard: null,
  assessmentPeriodId: null,
  targetedLang: null
};
